import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { AddNumberFromAppRoutes } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/route/type'

export const AddNumberFromAppAccessLayout = observer(() => {
  const location = useLocation()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings_add_from_app}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `${NumbersPath.root}`,
        })
      }}
      onAccessSuccess={() => {
        if (!location.pathname.includes(AddNumberFromAppRoutes.selectAppAndNumbers)) {
          uiStore.changeRouteViaVue({
            method: 'replace',
            path: `${NumbersPath.addNumberFromApp.stepsRoot}`,
          })
        }
      }}
    />
  )
})
